export default "__VITE_ASSET__CaYN1GWA__";